/* eslint-disable */
require('./arrowLeft')
require('./arrowRight')
require('./calendar')
require('./chatBlue')
require('./chatWhite')
require('./close')
require('./closeWhite')
require('./contact')
require('./down')
require('./downWhite')
require('./fileBlue')
require('./fileWhite')
require('./left')
require('./leftWhite')
require('./less')
require('./link')
require('./more')
require('./pdf')
require('./phone')
require('./profile')
require('./right')
require('./rightWhite')
require('./search')
require('./searchWhite')
require('./symptoms')
require('./tick')
require('./up')
require('./upWhite')
